import * as XLSX from "xlsx";

function normalizeExportRows(payload) {
  if (typeof payload === "string") {
    const workbook = XLSX.read(payload, { type: "string" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    return XLSX.utils.sheet_to_json(worksheet, { defval: "" });
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload && payload.data)) {
    return payload.data;
  }

  return [];
}

function pickColumnKey(sampleRow, aliases) {
  if (!sampleRow) return "";

  const keys = Object.keys(sampleRow);
  const normalizedMap = keys.reduce((acc, key) => {
    acc[key.toLowerCase().replace(/[^a-z0-9]/g, "")] = key;
    return acc;
  }, {});

  for (const alias of aliases) {
    const direct = keys.find((key) => key === alias);
    if (direct) return direct;

    const normalizedAlias = alias.toLowerCase().replace(/[^a-z0-9]/g, "");
    if (normalizedMap[normalizedAlias]) {
      return normalizedMap[normalizedAlias];
    }
  }

  return "";
}

function sanitizeSheetName(name, usedNames) {
  const base =
    String(name || "Sheet")
      .replace(/[[\]\\/?*:]/g, "-")
      .trim() || "Sheet";

  let candidate = base.slice(0, 31);
  let counter = 1;

  while (usedNames.has(candidate)) {
    const suffix = ` (${counter})`;
    candidate = `${base.slice(0, Math.max(0, 31 - suffix.length))}${suffix}`;
    counter += 1;
  }

  usedNames.add(candidate);
  return candidate;
}

function buildExportWorkbook(rows, groupBy) {
  const workbook = XLSX.utils.book_new();
  const usedNames = new Set();
  const headers = rows.length ? Object.keys(rows[0]) : [];

  if (!rows.length) {
    const worksheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Enrollees");
    return workbook;
  }

  if (groupBy === "provider") {
    const providerKey = pickColumnKey(rows[0], [
      "Provider",
      "provider",
      "provider_name",
      "Health Provider",
    ]);

    const sheetMap = {};

    rows.forEach((row) => {
      const groupName =
        String(row[providerKey] || "Unknown Provider").trim() ||
        "Unknown Provider";

      if (!sheetMap[groupName]) {
        const sheetName = sanitizeSheetName(groupName, usedNames);
        const worksheet = headers.length
          ? XLSX.utils.aoa_to_sheet([headers])
          : XLSX.utils.aoa_to_sheet([]);

        sheetMap[groupName] = {
          worksheet,
        };

        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      }

      XLSX.utils.sheet_add_json(sheetMap[groupName].worksheet, [row], {
        header: headers,
        skipHeader: true,
        origin: -1,
      });
    });

    return workbook;
  }



  if (groupBy === "hmo") {
    const hmoKey = pickColumnKey(rows[0], [
      "HMO",
      "hmo",
      "hmo_name",
      "Health Maintenance Organization",
    ]);

    const sheetMap = {};

    rows.forEach((row) => {
      const groupName =
        String(row[hmoKey] || "Unknown HMO").trim() ||
        "Unknown HMO";

      if (!sheetMap[groupName]) {
        const sheetName = sanitizeSheetName(groupName, usedNames);
        const worksheet = headers.length
          ? XLSX.utils.aoa_to_sheet([headers])
          : XLSX.utils.aoa_to_sheet([]);

        sheetMap[groupName] = {
          worksheet,
        };

        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      }

      XLSX.utils.sheet_add_json(sheetMap[groupName].worksheet, [row], {
        header: headers,
        skipHeader: true,
        origin: -1,
      });
    });

    return workbook;
  }

   

  if (groupBy === "place_of_work") {
    // const mdaKey = pickColumnKey(rows[0], ["Establishment", "Place of Work", "MDA"]);
    const establishmentKey = pickColumnKey(rows[0], ["Establishment"]);

    const sheetMap = {};

    rows.forEach((row) => {
      // const hmo = String(row[hmoKey] || "Unknown HMO").trim() || "Unknown HMO";
      const establishment =
        String(row[establishmentKey] || "Unknown Establishment").trim() ||
        "Unknown Establishment";
      const groupName = `${establishment}`;

      if (!sheetMap[groupName]) {
        const sheetName = sanitizeSheetName(groupName, usedNames);
        const worksheet = headers.length
          ? XLSX.utils.aoa_to_sheet([headers])
          : XLSX.utils.aoa_to_sheet([]);

        sheetMap[groupName] = {
          worksheet,
        };

        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
      }

      XLSX.utils.sheet_add_json(sheetMap[groupName].worksheet, [row], {
        header: headers,
        skipHeader: true,
        origin: -1,
      });
    });

    return workbook;
  }

  const worksheet = XLSX.utils.json_to_sheet(rows);
  XLSX.utils.book_append_sheet(workbook, worksheet, "Enrollees");
  return workbook;
}

export function downloadGroupedXlsx(payload, groupBy, fileName) {
  const exportRows = normalizeExportRows(payload);
  const workbook = buildExportWorkbook(exportRows, groupBy);
  XLSX.writeFile(workbook, fileName);
}
